/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type V2023_1KartePlannerCommentMonthlyAmountFragment = { usage: number, upperLimit: number | null };

export const V2023_1KartePlannerCommentMonthlyAmountFragmentDoc = gql`
    fragment V2023_1KartePlannerCommentMonthlyAmount on V2023_1KartePlannerCommentMonthlyAmount {
  usage
  upperLimit
}
    `;